import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Icon, Menu, Transition } from "semantic-ui-react";
import { privateRoutes } from "../utils/routes";

const MenuStructure = props => (
  <Transition
    key={`transition-${props.name}`}
    animation="fly right"
    duration={1000}
    visible={props.visible}
  >
    <Menu inverted vertical fixed="left">
      {props.back && (
        <Menu.Item onClick={props.toggleSubMenu(props.name)}>
          <Icon name="caret left" />
          Back to {props.title}
        </Menu.Item>
      )}
      {props.routes.map((route, index) => {
        if (route.private === false) return false;
        if (route.subNav && route.routes) {
          return (
            <Menu.Item
              key={`menuitem-${route.name}-${index}`}
              onClick={props.toggleSubMenu(route.name)}
            >
              <Icon name="caret right" />
              {route.title}
            </Menu.Item>
          );
        }
        // Remove all empty params from the path
        let path = route.path;
        path = path.replace("/:id?", "");
        path = path.replace("/:method?", "");
        path = path.replace("/:action?", "");

        return (
          <Menu.Item
            key={`menuitem-${route.name}-${index}`}
            as={Link}
            to={path}
          >
            {route.title}
          </Menu.Item>
        );
      })}
    </Menu>
  </Transition>
);

function buildMenu(routes, title, mainMenus, self) {
  const { config } = self.props;
  if (typeof routes === "undefined") return;
  routes.map(route => {
    if (route.private === false) return false;
    let isVisible = false;
    if (self.state[route.name]) isVisible = true;
    if (!self.props.shown) isVisible = false;

    // Build Sub Menu
    if (route.routes) {
      // Remove Menu Items for features that are not enabled
      let filteredSubRoutes = route.routes.filter(function (el) {
        if (
          (config && config.backend_type !== 'bep' && el['name'] === "settingsPrinters") ||
          (config && !config.web_sales_enabled && el['name'] === "contentManagerWebSales") ||
          (config && !config.web_sales_enabled && el['name'] === "contentManagerPages") ||
          (config && !config.web_sales_enabled && el['name'] === "customEmailBody") ||
          (config && !config.web_sales_enabled && el['name'] === "settingsWeb") ||
          (config && !config.web_sales_enabled && el['name'] === "settingsBitmask")
        ) {
          return false;
        }
        return true;
      });

      mainMenus.push(
        <MenuStructure
          routes={filteredSubRoutes}
          toggleSubMenu={self.toggleSubMenu}
          name={route.name}
          title={title}
          back={true}
          visible={isVisible}
        />
      );
      route.routes.map(sub => {
        return buildMenu(sub.routes, route.title, mainMenus, self);
      });
      // use to do really recursive
      buildMenu(route.routes, route.title, mainMenus, self);
    }
    return mainMenus;
    // mainMenus.push(route);
  });
  return mainMenus;
}

class MainNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false,
      menusShown: [],
      visible: false
    };
  }
  componentDidMount = () => {
    this.defaultShown();
  };
  componentDidUpdate = prevProps => {
    if (this.props.location !== prevProps.location) {
      this.defaultShown();
    }
  };
  defaultShown = (routes) => {
    this.setState({ mounted: false });
    let location = this.props.location.pathname;
    if (!routes) routes = privateRoutes;
    routes.map(route => {
      let rootPath = route.path;
      rootPath = rootPath.replace("/:id?", "");
      rootPath = rootPath.replace("/:action?", "");
      rootPath = rootPath.replace("/:method?", "");

      if (
        !this.state[route.name] &&
        location.indexOf(rootPath) > -1 &&
        route.subNav === true
      ) {
        this.setState({ [route.name]: true });
      }
      if (typeof route.routes !== "undefined") this.defaultShown(route.routes);
      this.setState({ mounted: true });
      return true;
    });
  };
  toggleSubMenu = prop => () => {
    this.setState(state => ({ [prop]: !state[prop] }));
  };
  showSubMenu = menu => {
    let menus = this.state.menusShown;
    menus.push(menu);
    this.setState({ visible: true, menusShown: menus });
  };
  hideSubMenu = () => {
    let menus = this.state.menusShown;
    menus.pop();
    this.setState({ visible: false, menusShown: menus });
  };

  render() {
    const { shown, config } = this.props;
    // Remove Menu Items for features that are not enabled
    let filteredRoutes = privateRoutes.filter(function (el) {
      if (
        (config && !config.subscription_enabled && el['name'] === "subscriptions") ||
        (config && !config.beneficiary_enabled && el['name'] === "beneficiaries")
      ) {
        return false;
      }
      return true;
    });

    const menus = buildMenu(filteredRoutes, 'Main Menu', [], this);
    if (!this.state.mounted) return <Container fluid id="sideNav" className={shown ? "shown" : ""} />;
    return (
      <Container fluid id="sideNav" className={shown ? "shown" : ""}>
        <MenuStructure
          routes={filteredRoutes}
          toggleSubMenu={this.toggleSubMenu}
          visible={shown}
        />
        {menus.map((menu, index) => (
          <MenuStructure key={`mainMenu-${index}`} {...menu.props} />
        ))}
      </Container>
    );
  }
}

export default MainNav;
